import React, { useState } from "react";
import Welcome from "./Welcome";
import AddFirstFunnel from "./AddFirstFunnel";
import AddReasonsDiscard from "./AddReasonsDiscard";
import AddProducts from "./AddProducts";
import Finish from "./Finish";
import ChooseIntegrations from "./ChooseIntegrations";

const TOTAL_STEPS = 6

const InitialSetup = ({ statusSetup, finishSetup, updateSetupProgress, verifyInitialSetup }) => {
    const [defaultStep, setDefaultStep] = useState(null)

    const goToStep = async (step) => {
        const updated = await updateSetupProgress(step)
        if (!updated) return

        setDefaultStep(step - 1)
        await verifyInitialSetup()
    }

    const getProgress = (stepDefault = null) => {
        if (stepDefault !== null && stepDefault >= 0) {
            return listSetup[stepDefault]
        }
        const persistedStep = Math.min(TOTAL_STEPS, Math.max(1, Number(statusSetup?.setupCurrentStep) || 1))
        return listSetup[persistedStep - 1]
    }

    const listSetup = [
        <Welcome nextStep={() => goToStep(2)} step={1} totalSteps={TOTAL_STEPS} />,
        <AddFirstFunnel nextStep={() => goToStep(3)} funnel_id={statusSetup?.funnelsExists ? statusSetup?.funnel_id : undefined} step={2} totalSteps={TOTAL_STEPS} />,
        <AddReasonsDiscard nextStep={() => goToStep(4)} step={3} totalSteps={TOTAL_STEPS} />,
        <AddProducts nextStep={() => goToStep(5)} step={4} totalSteps={TOTAL_STEPS} />,
        <ChooseIntegrations nextStep={() => goToStep(6)} step={5} totalSteps={TOTAL_STEPS} />,
        <Finish finishSetup={finishSetup} step={6} totalSteps={TOTAL_STEPS} />,
    ]

    return (
        <>
            {statusSetup && getProgress(defaultStep)}
        </>
    )
}

export default InitialSetup
